import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { LocalService } from '../local.services';
import { takeUntil } from 'rxjs/operators';
import { Local } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { ProgressService } from '../probress-steps/progress.services';
import { ToastrService } from 'ngx-toastr';
import { PlantType, Types } from './Plant-type';

@Component({
    selector: 'app-local-step-7',
    templateUrl: './step7.component.html',
    styleUrls: ['./step7.component.scss']
})
export class AppStep7Component implements OnInit, AfterViewInit,  OnDestroy {
    local_id: any;
    regForm: FormGroup;
    regFormErrors: any;
    local: Local;
    loading = false;
    private _unsubscribeAll: Subject<any>;
    plantsType: PlantType[] = [];
    selectType: any;

    constructor(private _appConfig: AppConfigService,
        private _formBuilder: FormBuilder,
        private _activatedRoute: ActivatedRoute,
        private _scrollService: ScrollService,
        private _toastr: ToastrService,
        private _router: Router, private _localService: LocalService,
        private _progressService: ProgressService) {
        this._appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                },
                vertical: 'none'
            }
        });
        this.regFormErrors = {
            flag_owner_place: {}
        };
        this.local = new Local();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this._activatedRoute.queryParams.subscribe(queryParams => {
            this._activatedRoute.params.subscribe(async routeParams => {
                this.local_id = await routeParams.id;
            });
        });

        this.regForm = this._formBuilder.group({
            plant_type_id: [this.local.plant_type_id]
        });
        this.regForm.valueChanges.subscribe(() => {
            this.onRegisterFormValuesChanged();
        });
        this._localService.plantsOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                this.plantsType = data;
            });

        this._localService.localOnChanged.pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.local = new Local(local);
                if (this.local.plant_type_id !== null) {
                    const plant_type_id = Number(this.local.plant_type_id);
                    this.regForm.get('plant_type_id').setValue(plant_type_id);
                    this.onChangeType(plant_type_id);
                }
            });
    }

    ngAfterViewInit() {
        this._scrollService._init();
    }

    next() {
        this._router.navigate([`/local/registro/8/${this.local_id}`]);
    }

    onSubmit() {

        if (this.regForm.valid) {
            this.loading = true;
            const plant_type_id = this.regForm.get('plant_type_id').value;
            const data: any = {
                plant_type_id: plant_type_id,

            };
            if (this.regForm.get('plant_type_id').value) {
                data.steps = this._progressService.getCurrentIndex(7);
            }

            this._localService.update(data)
                .then((res: any) => {
                    this._router.navigate([`/local/registro/8/${this.local_id}`]);
                }).catch((err: any) => {
                    this._toastr.error('Ocurrió un error, inténtalo nuevamente.');
                    this.loading = false;
                });


        }

    }

    onRegisterFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }
            this.regFormErrors[field] = {};
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    prev() {
        this._router.navigate([`/local/registro/6/${this.local_id}`]);

    }
    onChangeType(id: number, $event?) {
        console.log(id);
        console.log(this.plantsType);
        const result = this.plantsType.find(item => item.id === id);
        if (result) {
            this.selectType = result;
        }
    }


}
